class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content = this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends HTMLElement {
  connectedCallback() {
    this.detail = this.querySelector("details");
    if (!this.detail) return;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.detail.addEventListener("toggle", (event) => {
      if (event.target === this.detail && this.detail.open) {
        document.querySelectorAll("header-menu").forEach((menu) => {
          if (menu !== this && menu.detail?.open) menu.closeMenu?.();
        });
      }
      this.syncState();
    }, { ...options, capture: true });
    this.detail.querySelector("summary").addEventListener("click", (event) => {
      if (event.target.closest("a") && !this.detail.open) {
        event.preventDefault();
        this.openMenu();
      }
    }, options);
    this.addEventListener("pointerenter", (event) => {
      clearTimeout(this.closeTimer);
      if (event.pointerType === "mouse" && matchMedia("(hover: hover) and (min-width: 990px)").matches) this.openMenu();
    }, options);
    this.addEventListener("pointerleave", (event) => {
      if (event.pointerType !== "mouse") return;
      this.closeTimer = setTimeout(() => {
        if (!this.contains(document.activeElement)) this.closeMenu();
      }, 150);
    }, options);
    this.addEventListener("focusout", () => {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.closeMenu();
      }, 0);
    }, options);
    this.addEventListener("keydown", (event) => {
      if (event.key !== "Escape" || !this.detail.open) return;
      event.preventDefault();
      event.stopPropagation();
      const nested = event.target.closest("details[open]");
      if (nested && nested !== this.detail) {
        nested.open = false;
        nested.querySelector("summary").focus();
      } else {
        this.closeMenu();
        this.detail.querySelector("summary").focus();
      }
    }, options);
    document.addEventListener("pointerdown", (event) => {
      if (!this.contains(event.target)) this.closeMenu();
    }, options);
    window.addEventListener("resize", () => {
      if (innerWidth < 990) this.closeMenu();
      else this.updateBounds();
    }, options);
    this.syncState();
  }

  disconnectedCallback() {
    this.controller?.abort();
    clearTimeout(this.closeTimer);
    this.closeMenu();
  }

  openMenu() {
    document.querySelectorAll("header-menu").forEach((menu) => {
      if (menu !== this) menu.closeMenu?.();
    });
    this.detail.open = true;
    this.syncState();
  }

  closeMenu() {
    this.querySelectorAll("details").forEach((detail) => { detail.open = false; });
    this.syncState();
  }

  updateBounds() {
    const header = this.closest(".header-wrapper");
    const bottom = header?.getBoundingClientRect().bottom ?? this.getBoundingClientRect().bottom;
    this.style.setProperty("--menu-available-height", Math.max(120, innerHeight - Math.max(0, bottom) - 16) + "px");
  }

  syncState() {
    if (!this.detail) return;
    this.querySelectorAll("details").forEach((detail) => {
      detail.querySelector("summary")?.setAttribute("aria-expanded", String(detail.open));
    });
    this.detail.classList.toggle("menu--open", this.detail.open);
    if (this.detail.open) this.updateBounds();
    const anyOpen = !!document.querySelector("header-menu > details[open]");
    document.body.classList.toggle("mega-menu--active", anyOpen);
    document.body.classList.toggle("has-dropdown-menu", anyOpen);
    const header = this.closest(".header-wrapper");
    if (header) header.preventHide = anyOpen;
  }
}

customElements.define("header-menu", HeaderMenu);
